<template>
    <div class="toast show">
        <slot></slot>
    </div>  
</template>
